module.exports = __webpack_public_path__ + "static/media/itf.2efba5a9.png";